import { CheckMarkIcon } from '@/assets/icons/check-mark';
import color from '@/core/features/styles/color';

type CheckBoxBorderProps = {
    className?: string;
    hasHoverEffect?: boolean;
    isDisabled?: boolean;
    isSelected: boolean;
    onClick?: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
};

export default function CheckBox({
    className,
    hasHoverEffect = false,
    isDisabled,
    isSelected,
    onClick,
}: CheckBoxBorderProps) {
    const isHovered = hasHoverEffect && !isDisabled;

    return (
        <span
            className={`flex-center checkbox ${isHovered ? 'checkboxHovered' : ''} ${isSelected ? 'isSelected' : ''} ${className ?? ''}`}
            onClick={onClick}
        >
            {isSelected && (
                <CheckMarkIcon
                    color={color('white')}
                    height={10}
                    width={14}
                />
            )}
            <style jsx>{`
                .checkbox {
                    width: 22px;
                    height: 22px;
                    margin-bottom: 1px;
                    border-radius: 3px;
                    border: ${isSelected ? 'none' : '1px solid'};
                    border-color: ${isDisabled ? color('alto') : color('nobel')};
                    background-color: ${isSelected ? color('endeavour') : 'transparent'};
                }
                .checkboxHovered:hover {
                    border-color: ${color('endeavour')};
                }
            `}</style>
        </span>
    );
}
